import React, { useEffect, useState } from 'react';
import "./Orders.css";
import { firestore, auth } from '../../firebase/firebaseConfig';
import { onSnapshot, collection, query, orderBy, deleteDoc, doc, where, getDocs, updateDoc, addDoc, getDoc } from "@firebase/firestore";
import { onAuthStateChanged } from 'firebase/auth';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/esm/Button';
import { Modal, Popconfirm, Radio, message } from "antd";

function Orders ( props ) {
    let [ orders, setOrders ] = useState( [] );
    const [ open, setOpen ] = useState( false );
    const [ confirmLoading, setConfirmLoading ] = useState( false );
    const [ paymentMethod, setPaymentMethod ] = useState( "wallet" );
    const [ wallet, setWallet ] = useState( 0 );
    const [ paymentObject, setPaymentObject ] = useState( {} );
    const [messageApi, contextHolder] = message.useMessage();

    async function onload ( user ) {
        onSnapshot( query( collection( firestore, "users/" + user.uid + "/user_orders" ), orderBy( "order_id", "desc" ) ), ( snapShot ) => {
            document.querySelector( ".loader-container" ).style.display = "flex";
            let ordersRaw = [];
            snapShot.forEach( ( element ) => {
                let names = "";
                JSON.parse( element.data().cart_items ).forEach( ( element ) => {
                    names = names + element.category + ", ";
                } )
                ordersRaw.push( {
                    order_id: element.data().order_id,
                    order_doc_id: element.id,
                    order_total: element.data().order_total,
                    order_time: element.data().order_time.toDate().toString().substring( 0, 25 ),
                    names: names.substring( 0, names.length - 2 ),
                    status: element.data().status
                } )
            } )
            setOrders( [ ...ordersRaw ] );
            document.querySelector( ".loader-container" ).style.display = "none";
        } );

        onSnapshot( doc( firestore, "users/" + user.uid + "/wallet", "wallet_id" ), ( snapshot ) => {
            setWallet( snapshot.data().wallet_balance )
        } )
    }

    async function cancelOrder ( event, id ) {
        await deleteDoc( doc( firestore, "users/" + auth.currentUser.uid + "/user_orders", id ) );
        let cancelOrderDocs = await getDocs( query( collection( firestore, "orders_temp/upcoming_orders_id/upcoming_orders" ), where( "order_doc", "==", id ) ) );
        await deleteDoc( doc( firestore, "orders_temp/upcoming_orders_id/upcoming_orders", cancelOrderDocs.docs[ 0 ].id ) );
    }

    async function handleOk () {
        let cancelOrderDocs = await getDocs( query( collection( firestore, "orders_temp/accepted_orders_id/accepted_orders" ), where( "order_doc", "==", paymentObject.id ) ) );
        if ( paymentMethod === "wallet" ) {
            let checkDoc = await getDoc( doc( firestore, "users/" + auth.currentUser.uid + "/wallet", "wallet_id" ) );
            if ( parseFloat( checkDoc.data().wallet_balance ) >= parseFloat( parseFloat( paymentObject.order_total ).toFixed( 2 ) ) ) {
                setConfirmLoading( true );
                await updateDoc( doc( firestore, "users/" + auth.currentUser.uid + "/user_orders", paymentObject.id ), {
                    status: "paid"
                } )
                await updateDoc( doc( firestore, "orders_temp/accepted_orders_id/accepted_orders", cancelOrderDocs.docs[ 0 ].id ), {
                    status: "paid"
                } )
                await updateDoc( doc( firestore, "users/" + auth.currentUser.uid + "/wallet", "wallet_id" ), {
                    wallet_balance: parseFloat( wallet ) - parseFloat( parseFloat( paymentObject.order_total ).toFixed( 2 ) )
                } )
                await addDoc( collection( firestore, "transaction_history_global" ), {
                    order_doc: paymentObject.id,
                    amount: parseFloat( parseFloat( paymentObject.order_total ).toFixed( 2 ) ),
                    order_total: parseFloat( parseFloat( paymentObject.order_total ).toFixed( 2 ) ),
                    customer_name: props.details.name,
                    via: "LB Wallet",
                    order_id: paymentObject.order_id,
                    customer_id: auth.currentUser.uid,
                    time: new Date(),
                    source: "website"
                } )
                await addDoc( collection( firestore, "users/" + auth.currentUser.uid + "/transaction_history" ), {
                    order_id: paymentObject.order_id,
                    amount: "-Rs. " + parseInt( parseFloat( paymentObject.order_total ).toFixed( 2 ) ),
                    timestamp: new Date(),
                    message: "Paid for Order ID " + paymentObject.order_id,
                    method: "Payment to Laundry Buddy",
                    source: "website"
                } )
                setConfirmLoading( false );
                setOpen( false );
            } else {
                error();
            }
        } else if ( paymentMethod === "other" ) {
            setOpen( false );
            var options = {
                "key": process.env.REACT_APP_RAZOR_KEY,
                "key_secret": process.env.REACT_APP_RAZOR_KEY_SECRET,
                "amount": ( parseInt( paymentObject.order_total ) * 100 ).toString(),
                "currency": "INR",
                "name": "Laundry Buddy",
                "description": "Payment for Order ID " + paymentObject.order_id,
                "image": btoa( require( "../../images/logo.webp" ) ),
                "handler": async function ( response ) {
                    await updateDoc( doc( firestore, "users/" + auth.currentUser.uid + "/user_orders", paymentObject.id ), {
                        status: "paid"
                    } )
                    await updateDoc( doc( firestore, "orders_temp/accepted_orders_id/accepted_orders", cancelOrderDocs.docs[ 0 ].id ), {
                        status: "paid"
                    } )
                    await addDoc( collection( firestore, "transaction_history_global" ), {
                        order_doc: paymentObject.id,
                        amount: parseFloat( parseFloat( paymentObject.order_total ).toFixed( 2 ) ),
                        order_total: parseFloat( parseFloat( paymentObject.order_total ).toFixed( 2 ) ),
                        customer_name: props.details.name,
                        via: "RazorPay",
                        order_id: paymentObject.order_id,
                        customer_id: auth.currentUser.uid,
                        time: new Date(),
                        source: "website"
                    } )
                    await addDoc( collection( firestore, "users/" + auth.currentUser.uid + "/transaction_history" ), {
                        order_id: paymentObject.order_id,
                        amount: "-Rs. " + parseInt( parseFloat( paymentObject.order_total ).toFixed( 2 ) ),
                        timestamp: new Date(),
                        message: "Paid for Order ID " + paymentObject.order_id,
                        method: "Payment to Laundry Buddy",
                        source: "website"
                    } )
                },
                "prefill": {
                    "name": props.details.name, //your customer's name
                    "email": props.details.email,
                    "contact": props.details.phone
                },
                "theme": {
                    "color": "#3399cc"
                }
            };
            var rzp1 = new window.Razorpay( options );
            rzp1.on( 'payment.failed', function ( response ) {
                console.log( response );
            } );
            rzp1.open();
        }
    }

    const error = () => {
        messageApi.open( {
            type: 'error',
            content: 'There is insufficient balance in your LB Wallet.',
            style: {
                marginTop: "10%"
            }
        } );
    };

    useEffect( () => {
        document.title = "Laundry Buddy - Order History";
        document.querySelector( ".loader-container" ).style.display = "flex";
        onAuthStateChanged( auth, ( user ) => {
            if ( user ) {
                onSnapshot( doc( firestore, "users", user.uid ), ( snapshot ) => {
                    if ( snapshot.exists() ) {
                        props.settingDetails( {
                            name: snapshot.data().name,
                            phone: snapshot.data().mobile,
                            email: snapshot.data().email,
                            address: snapshot.data().address,
                            pincode: snapshot.data().pincode
                        } )
                        onload( user );
                    } else {
                        window.location.href = "/signup";
                    }
                } );
            } else {
                window.location.href = "/";
            }
        } )
    }, [] )

    return (
        <div className='orders-container'>
            <Modal
                title="Select the Payment Mode"
                style={{ width: "400px" }}
                open={open}
                onOk={handleOk}
                confirmLoading={confirmLoading}
                onCancel={event => setOpen( false )}
            >
                <Radio.Group name="paymentMode" defaultValue={"wallet"} style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }} onChange={event => { setPaymentMethod( event.target.value ); }}>
                    <Radio value={"wallet"}>Wallet (upto 20% off)</Radio>
                    <Radio value={"other"}>Other Payment Methods</Radio>
                </Radio.Group>
            </Modal>
            <h2>Orders</h2>
            {contextHolder}
            {orders.map( ( element ) => (
                <div className='order-container laptop'>
                    <div className='order-container-1'>
                        <div className='order-container-image'>
                            <img src={require( "../../images/logo.webp" )} alt="" />
                        </div>
                        <div className='order-user-info'>
                            <div>
                                {props.details.name}
                            </div>
                            <div>
                                {element.order_id}
                            </div>
                        </div>
                    </div>
                    <div className='order-container-2'>
                        <div>
                            ITEMS
                        </div>
                        <div>
                            {element.names}
                        </div>
                    </div>
                    <div className='order-container-3'>
                        <div>
                            ORDERED ON
                        </div>
                        <div>
                            {element.order_time.toString()}
                        </div>
                    </div>
                    <div className='order-container-4'>
                        <div>
                            Rs. {element.order_total}
                        </div>
                    </div>
                    <div className='order-container-5'>
                        {element.status === "accepted" && <Button onClick={event => {
                            setOpen( true );
                            setPaymentObject( {
                                order_total: element.order_total,
                                id: element.order_doc_id,
                                order_id: element.order_id
                            } )
                        }}>
                            Pay Now
                        </Button>}
                        {element.status === "paid" && <Button>
                            Paid
                        </Button>}
                        <Popconfirm
                            placement="bottomRight"
                            title="Cancel the Order"
                            description={"Are you sure you want to cancel the order with id " + element.order_id}
                            onConfirm={event => cancelOrder( event, element.order_doc_id )}
                            okText="Yes"
                            cancelText="No"
                        >
                            {element.status === "pending" && <Button>
                                Cancel
                            </Button>}
                        </Popconfirm>
                        <Button>
                            <Link to={"/orders/" + element.order_doc_id}>Track Order</Link>
                        </Button>
                    </div>
                </div>
            ) )
            }

            {
                orders.map( ( element ) => (
                    <div className='order-container mobile'>
                        <div className='order-container-1'>
                            <div>
                                <div className='order-container-image'>
                                    <img src={require( "../../images/logo.webp" )} alt="" />
                                </div>
                                <div className='order-user-info'>
                                    <div>
                                        {props.details.name}
                                    </div>
                                    <div>
                                        {element.order_id}
                                    </div>
                                </div>
                            </div>
                            <div>
                                Rs. {element.order_total}
                            </div>
                        </div>
                        <div className='order-container-2'>
                            <div>
                                ITEMS
                            </div>
                            <div>
                                {element.names}
                            </div>
                        </div>
                        <div className='order-container-3'>
                            <div>
                                ORDERED ON
                            </div>
                            <div>
                                {element.order_time.toString()}
                            </div>
                        </div>
                        <div className='order-container-5'>
                            {element.status === "accepted" && <Button onClick={event => {
                                setOpen( true );
                                setPaymentObject( {
                                    order_total: element.order_total,
                                    id: element.order_doc_id,
                                    order_id: element.order_id
                                } )
                            }}>
                                Pay Now
                            </Button>}
                            {element.status === "paid" && <Button>
                                Paid
                            </Button>}
                            <Popconfirm
                                placement="bottomRight"
                                title="Cancel the Order"
                                description={"Are you sure you want to cancel the order with id " + element.order_id}
                                onConfirm={event => cancelOrder( event, element.order_doc_id )}
                                okText="Yes"
                                cancelText="No"
                            >
                                {element.status === "pending" && <Button>
                                    Cancel
                                </Button>}
                            </Popconfirm>
                            <Button>
                                <Link to={"/orders/" + element.order_doc_id}>Track Order</Link>
                            </Button>
                        </div>
                    </div>
                ) )
            }
        </div >
    )
}

export default Orders